import { render, staticRenderFns } from "./excessivePage.vue?vue&type=template&id=53a9959b&scoped=true&"
import script from "./excessivePage.vue?vue&type=script&lang=js&"
export * from "./excessivePage.vue?vue&type=script&lang=js&"
import style0 from "./excessivePage.vue?vue&type=style&index=0&id=53a9959b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a9959b",
  null
  
)

export default component.exports